const colorsNormal = {
    black: '#1A171B',
    blackLink: '#1A171B',
    black10: '#000000D9',
    blackLink10: '#000000D9',
    black40: '#1A171B60',
    blackLink40: '#1A171B60',
    blackToBlack: '#1A171B',
    white: '#FFFFFF',
    whiteToWhite: '#FFFFFF',
    whiteLink: '#FFFFFF',
    white20: '#FFFFFF20',
    orange: '#EC6E0C',
    orange30: '#EC6E0C4D',
    orangeLink: '#EC6E0C',
    lightOrange: '#F49E00',
    lightOrangeLink: '#F49E00',
    orangeToBlack: '#EC6E0C',
    borderGreyLink: '#d5d5d5',
    grey: '#5B5B5F',
    grey20: '#5B5B5F33',
    greyLink: '#5B5B5F',
    greyLink50: '#5B5B5F80',
    grey10: '#5B5B5F1A',
    lightGrey: '#F5F5F5',
    lightGreyLink: '#F5F5F5',
    lightGrey20: '#5B5B5F33',
    lightGrey20Link: '#5B5B5F33',
    lightGrey40: '#5B5B5F66',
    lightGreyLink40: '#5B5B5F66',
    disabledGrey: '#BCBCBC',
    disabledGrey10: '#5B5B5F1A',
    highLightGrey: '#64646429',
    greyToBlack: '#5B5B5F',
    darkGrey: '#3C393C',
    borderWhite: 'transparent',
    borderYellow: 'transparent',
    borderLightGrey: '#F5F5F5',
    borderLightGreyLink40: '#5B5B5F66',
    backgroundTransparent: 'transparent',
    hoverOrangeLink: '#F9EDD3',
    hoverOrangeTransparent: '#F9EDD3',
    red: '#EC130F',
    redLink: '#EC130F',
    error10: '#ec130f1a',
    warning: '#fff3cd',
    info: '#e7f2f8',
    hoverTable: '#F9EDD3',
    hoverTableLink: '#F9EDD3',
    blue: '#0B7EB5',
    blueLink: '#0B7EB5',
    blue10: '#0B7EB510',
    green: '#0B8A1C',
    greenLink: '#0B8A1C',
    green10: '#0B8A1C10',
    yellow: '#F49E00',
    yellow10: '#F49E0010',
    success10: '#02910f1a',
};

const contrast = {
    black: '#FFFFFF',
    blackLink: '#FFF333',
    black10: '#FFFFFF',
    blackLink10: '#FFF333',
    black40: '#FFFFFF',
    blackLink40: '#FFF333',
    blackToBlack: '#1A171B',
    white: '#000000',
    whiteToWhite: '#FFFFFF',
    whiteLink: '#FFF333',
    white20: '#000000',
    orange: '#FFFFFF',
    orange30: '#FFFFFF',
    orangeLink: '#FFF333',
    lightOrange: '#FFFFFF',
    lightOrangeLink: '#FFF333',
    orangeToBlack: '#000000',
    borderGreyLink: '#FFF333',
    grey: '#FFFFFF',
    grey20: '#FFFFFF',
    greyLink: '#FFF333',
    greyLink50: '#FFF333',
    grey10: '#5B5B5F1A',
    lightGrey: '#000000',
    lightGreyLink: '#FFF333',
    lightGreyLink40: '#FFF333',
    lightGrey40: '#FFFFFF',
    lightGrey20: '#FFFFFF',
    lightGrey20Link: '#FFF333',
    highLightGrey: '#FFFFFF',
    greyToBlack: '#000000',
    darkGrey: '#000000',
    disabledGrey: '#FFFFFF',
    disabledGrey10: '#000000',
    backgroundTransparent: '#000000',
    borderWhite: '#FFFFFF',
    borderYellow: '#FFF333',
    borderLightGrey: '#FFFFFF',
    borderLightGreyLink40: '#FFF333',
    hoverOrangeLink: '#FFF333',
    hoverOrangeTransparent: 'transparent',
    red: '#FFFFFF',
    redLink: '#FFF333',
    error10: '#000000',
    warning: '#000000',
    info: '#000000',
    hoverTable: '#FFFFFF',
    hoverTableLink: '#FFF333',
    blue: '#FFFFFF',
    blueLink: '#FFF333',
    blue10: '#000000',
    green: '#FFFFFF',
    greenLink: '#FFF333',
    green10: '#000000',
    yellow: '#FFFFFF',
    yellow10: '#000000',
    success10: '#000000',
};

const theme = {
    colorsNormal,
    contrast,
    padding: {
        x1: '8px',
        x2: '16px',
        x3: '24px',
        x4: '32px',
        x5: '40px',
        x6: '48px',
        button: '12px 24px',
        alert: '22px 24px',
        menu: '12px 16px',
    },

    margin: {
        x1: '8px',
        x2: '16px',
        x3: '24px',
        x4: '32px',
        x5: '40px',
        x6: '48px',
    },

    font: {
        h1: 'normal normal bold 60rem/76rem Oxygen',
        h2: 'normal normal bold 48rem/60rem Oxygen',
        h3: 'normal normal bold 36rem/45rem Oxygen',
        h4: 'normal normal bold 24rem/31rem Oxygen',
        h5: 'normal normal bold 20rem/26rem Oxygen',
        h6: 'normal normal bold 18rem/22rem Oxygen',
        subtitle: 'normal normal bold 16rem/20rem Oxygen',
        size5: '5rem',
        size6: '6rem',
        size7: '7rem',
        size8: '8rem',
        size9: '9rem',
        size10: '10rem',
        size11: '11rem',
        size12: '12rem',
        size14: '14rem',
        size15: '15rem',
        size16: '16rem',
        size17: '17rem',
        size18: '18rem',
        size20: '20rem',
        size21: '21rem',
        size22: '22rem',
        size24: '24rem',
        size26: '26rem',
        size36: '36rem',

        body: {
            1: 'normal normal normal 16rem/24rem Oxygen',
            2: 'normal normal normal 14rem/21rem Oxygen',
            3: 'normal normal bold 16rem/14rem Oxygen',
            4: 'normal normal bold 14rem/17rem Oxygen',
            5: 'normal normal normal 14rem/24rem Oxygen',
            6: 'normal normal normal 14rem/17rem Oxygen',
            7: 'normal normal normal 12px/21px Oxygen',
        },
        button: {
            1: 'normal normal bold 16rem/20rem Oxygen',
            2: 'normal normal bold 14rem/17rem Oxygen',
        },
        link: 'normal normal bold 16rem/14rem Oxygen',
        table: {
            header: 'normal normal normal 14rem/17rem Oxygen',
            body: 'normal normal normal 14rem/17rem Oxygen',
        },
        label: 'normal normal normal 14px/21px Oxygen',
        labelBold: 'normal normal bold 14px/21px Oxygen',
    },

    border: {
        radius: {
            button: '8px',
            table: '8px',
            card: '8px',
            modal: '8px',
        },
    },
};

export default theme;
